/* Zen for Men: one understated price breakdown beside the purchase button.
   Enhancement value comes from W3's own additional-cost summary.
   Display only; no changes to Shopify cart, W3 pricing, or linked add-on products. */
(() => {
  'use strict';
  if (window.__ycZenW3CompactTotalInstalled) return;
  window.__ycZenW3CompactTotalInstalled = true;

  const style = document.createElement('style');
  style.id = 'yc-zen-w3-compact-total-css';
  style.textContent = 'section[data-yc-holiday-package] .yc-zen-w3-original-summary{display:none!important}';
  document.head.append(style);

  const normalize = text => (text || '').replace(/\s+/g, ' ').trim();
  const formatMoney = value => '$' + value.toLocaleString('en-US', {
    minimumFractionDigits: value % 1 ? 2 : 0,
    maximumFractionDigits: 2
  });
  let observedForm = null, observer = null, frame = 0;

  function identifySummary(form) {
    const existing = form.querySelector('.yc-zen-w3-original-summary');
    if (existing) return existing;
    const headings = [...form.querySelectorAll('*')]
      .filter(el => /^additional added\s*:?$/i.test(normalize(el.textContent)));
    for (const heading of headings) {
      let ancestor = heading.parentElement;
      while (ancestor && ancestor !== form) {
        const content = normalize(ancestor.textContent).toLowerCase();
        if (content.includes('additional added') &&
            content.includes('total additional cost') &&
            !ancestor.querySelector('input,select,textarea,button,.yc-w3-choice-row')) {
          return ancestor;
        }
        ancestor = ancestor.parentElement;
      }
    }
    return null;
  }

  function updatePrice(enhancementAmount) {
    const panel = document.querySelector('section[data-yc-holiday-package] [data-yc-zen-price-breakdown]');
    if (!panel) return;
    const extrasRow = panel.querySelector('[data-yc-zen-extras-row]');
    const totalRow = panel.querySelector('[data-yc-zen-total-row]');
    const extras = panel.querySelector('[data-yc-zen-extras]');
    const total = panel.querySelector('[data-yc-zen-total]');
    const baseCents = Number(panel.dataset.baseCents);
    if (!Number.isFinite(baseCents)) return;
    const selected = enhancementAmount > 0;
    if (extrasRow && extrasRow.hidden !== !selected) extrasRow.hidden = !selected;
    if (totalRow && totalRow.hidden !== !selected) totalRow.hidden = !selected;
    const addonText = '+' + formatMoney(enhancementAmount);
    const totalText = formatMoney(baseCents / 100 + enhancementAmount);
    if (extras && extras.textContent !== addonText) extras.textContent = addonText;
    if (total && total.textContent !== totalText) total.textContent = totalText;
  }

  function update() {
    if (!observedForm?.isConnected) return;
    const summary = identifySummary(observedForm);
    if (!summary) {
      updatePrice(0);
      return;
    }
    const found = normalize(summary.textContent)
      .match(/total\s+additional\s+cost\s*:?\s*(?:USD\s*)?\$\s*([\d,]+(?:\.\d{1,2})?)/i);
    if (!found) return;
    const value = Number(found[1].replace(/,/g, ''));
    if (!Number.isFinite(value)) return;
    if (!summary.classList.contains('yc-zen-w3-original-summary')) {
      summary.classList.add('yc-zen-w3-original-summary');
    }
    updatePrice(value);
  }
  function queue() {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = 0; update(); });
  }
  function attach() {
    const root = document.querySelector('section[data-yc-holiday-package] .yc-w3-options-shell');
    if (!root) return;
    const form = root.closest('form');
    if (!form) return;
    if (form !== observedForm) {
      if (observer) observer.disconnect();
      observedForm = form;
      observer = new MutationObserver(queue);
      observer.observe(form, {childList:true,subtree:true,characterData:true});
    }
    queue();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, {once:true});
  else attach();
  document.addEventListener('shopify:section:load', attach);
  document.body.addEventListener('productOptionsLoadedJS', attach);
})();
